'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSenderKeyFromType = undefined;

var _cmfSenderTypes = require('../constants/cmfSenderTypes');

var _senderIdKeys = require('../constants/senderIdKeys');

var getSenderKeyFromType = exports.getSenderKeyFromType = function getSenderKeyFromType(type) {
  switch (type) {
    case _cmfSenderTypes.VID_SENDER:
      return _senderIdKeys.VID;
    case _cmfSenderTypes.VISITOR_SENDER:
      return _senderIdKeys.UTK;
    case _cmfSenderTypes.BOT_SENDER:
      return _senderIdKeys.ID;
    case _cmfSenderTypes.AGENT_SENDER:
      return _senderIdKeys.ID;
    case _cmfSenderTypes.SYSTEM_SENDER:
    default:
      return null;
  }
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/common-message-format/operators/getSenderKeyFromType.js
// module id = 690
// module chunks = 2 3